import React, {useEffect} from "react";
import {HashRouter} from 'react-router-dom';
import {PageRouter} from "./pageRouter";
import './App.css';
import {useAuth} from "react-oidc-context";
import {startWebSocket} from "../utils/wsClient";


export const App = () => {
    const auth = useAuth()

    useEffect(() => {
        startWebSocket(process.env.REACT_APP_WSS_URL, auth.user.id_token);
    })

    return (
        <HashRouter>
            <PageRouter></PageRouter>
        </HashRouter>
    )
}